<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.85)"
  size="medium"
  [fullScreen]="true"
  type=""
>
  <div class="tal-loader">
    <img src="assets/images/logo.png" alt="TAL" class="tal-loader__logo" />
    <p class="tal-loader__hint">{{ 'GLOBAL_LOADING_HINT' | translate }}</p>
  </div>
</ngx-spinner>
<p-confirmDialog></p-confirmDialog>





<!-- ✅ Toast Notifications (only when logged in) -->


<div
  class="toaster-container d-flex align-items-center justify-content-center"
>
  <div class="w-50">
    <div
      *ngFor="let notification of notifications"
      [ngClass]="notification.type"
      class="my-3 w-100 toaster"
    >
      <h5 class="col-10">
        {{ notification.message }}
      </h5>
      <div class="col-2 d-flex align-items-center justify-content-end">
        <button
          mat-icon-button
          class="btn_icon"
          (click)="removeNotification(notification)"
        >
          <i class="ri-close-circle-line"></i>
        </button>
      </div>
    </div>
  </div>
</div>

    <router-outlet></router-outlet>
    <div class="app-version-label">{{ versionLabel }}</div>

<!-- 🚀 Guest (not logged in) layout — no extra space -->
<!-- <ng-template #guestView>
  <div class="guest-content">
    <router-outlet></router-outlet>
  </div>
</ng-template> -->
